// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__A5wQX","text":"SelectPayment_text__1hOiy","title":"SelectPayment_title__3opyT","btn":"SelectPayment_btn__1Vk-g"};